<template>
  <v-dialog v-model="dialogVisible" 
    persistent
    width="100%"
    max-width="360px" 
  >
    <template v-slot:activator="scope">
      <activator-button :scope="scope" />
    </template>

    <v-form @submit.prevent="submitClick" autocomplete="off">
      <v-card>
        <v-card-text>
          <v-text-field
            outlined dense
            v-model="business_name"
            label="Business Name"
            autocomplete="business_name"
          ></v-text-field>
          <v-text-field
            outlined dense
            v-model="contact_name"
            label="Contact Name"
            autocomplete="business_contact"
          ></v-text-field>
          <v-text-field
            outlined dense
            v-mask="'(###) ###-####'"
            v-model="phone"
            label="Phone (leads)"
            autocomplete="lead_phone"
          ></v-text-field>
          <v-text-field
            outlined dense
            v-model="email"
            label="Email"
            autocomplete="business_email"
          ></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="justify-center">
          <v-btn @click="close">Cancel</v-btn>
          <v-btn color="primary" type="submit">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
  import { ActivatorButton } from '@/components/pages'

  import { mapActions } from 'vuex'

  export default {
    name: 'ProContactDialog',

    props: ['pro'],

    components: { ActivatorButton },
    
    data() {
      return {
        dialogVisible: false,

        business_name: "",
        contact_name: "",
        phone: "",
        email: "",
      };
    },

    watch: {
      dialogVisible(visible) {
        if( visible ) {
          this.business_name = this.pro.business_name
          this.contact_name = this.pro.contact_name
          this.phone = this.pro.phone
          this.email = this.pro.email
        }
      },
    },

    methods: {
      ...mapActions('auth', ['loadMe', 'updateMe']),

      close() {
        this.dialogVisible = false
      },

      async submitClick() {
        const payload = {
          business_name: this.business_name,
          contact_name: this.contact_name,
          phone: this.phone,
          email: this.email,
        }

        let result = await this.updateMe(payload)

        if( result.ok ) {          
          this.loadMe()
          this.close()
        }
      },
    
    },
  };
</script>

<style scoped>
  .v-dialog__content {
    position:  absolute;
  }
</style>